export default __webpack_public_path__ + "static/media/logo.5212c7b4.svg";